import React, { useEffect } from 'react';
import RatingModal from '@/components/RatingModal/RatingModal.tsx';
import { useModalStore } from '@/store/useModalStore.ts';
import { useWhoamiStore } from '@/store/useWhoamiStore.ts';
import Login from '@/pages/Authentication/Login/Login.tsx';
import styles from './ThankYouForFeedback.module.scss';
import MyClimate from '@/pages/MyClimate/MyClimate.tsx';

const ThankYouForFeedback: React.FC = () => {
	const { openModal, activeModal } = useModalStore();
	const { loggedIn } = useWhoamiStore();

	useEffect(() => {
		openModal('ratingModal');
	}, []);

	return (
		<>
			{loggedIn ? <MyClimate /> : <Login />}
			{activeModal && (
				<div className={styles.modalWrapper}>
					<RatingModal showThankYou />
				</div>
			)}
		</>
	);
};

export default ThankYouForFeedback;
